var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 30,
    viewBox: "0 0 110 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.736425 5.30714C0.519861 5.54624 0.394531 5.9185 0.394531 6.40058V23.5963C0.394531 24.0783 0.519861 24.4506 0.736425 24.6897L0.789876 24.7422L9.92611 15.1102V14.8828L0.789876 5.25077L0.736425 5.30714Z",
    fill: "url(#paint0_linear_5249_43499)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9639 18.3232L9.92188 15.111V14.8835L12.9676 11.6712L13.0358 11.713L16.6427 13.8776C17.6721 14.4918 17.6721 15.5027 16.6427 16.1208L13.0358 18.2814L12.9639 18.3232Z",
    fill: "url(#paint1_linear_5249_43499)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0399 18.2818L9.92601 14.9976L0.736328 24.6909C1.07822 25.0699 1.63576 25.1156 2.26979 24.7365L13.0399 18.2818Z",
    fill: "url(#paint2_linear_5249_43499)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0399 11.7138L2.26979 5.25915C1.63576 4.88398 1.07822 4.92966 0.736328 5.30871L9.92601 14.998L13.0399 11.7138Z",
    fill: "url(#paint3_linear_5249_43499)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3221 11.0096C49.9897 11.0096 48.0843 12.8817 48.0843 15.4647C48.0843 18.0267 49.9897 19.9185 52.3221 19.9185C54.6594 19.9185 56.5648 18.0267 56.5648 15.4647C56.5648 12.8817 54.6594 11.0096 52.3221 11.0096ZM52.3221 18.1642C51.0423 18.1642 49.9413 17.0501 49.9413 15.4647C49.9413 13.8583 51.0423 12.7639 52.3221 12.7639C53.6018 12.7639 54.7078 13.8583 54.7078 15.4647C54.7078 17.0501 53.6018 18.1642 52.3221 18.1642ZM43.0757 11.0096C40.7384 11.0096 38.838 12.8817 38.838 15.4647C38.838 18.0267 40.7384 19.9185 43.0757 19.9185C45.4118 19.9185 47.3135 18.0267 47.3135 15.4647C47.3135 12.8817 45.4118 11.0096 43.0757 11.0096ZM43.0757 18.1642C41.7947 18.1642 40.69 17.0501 40.69 15.4647C40.69 13.8583 41.7947 12.7639 43.0757 12.7639C44.3555 12.7639 45.4565 13.8583 45.4565 15.4647C45.4565 17.0501 44.3555 18.1642 43.0757 18.1642ZM32.073 12.3751V14.2681H36.3592C36.2338 15.3259 35.8986 16.1036 35.3848 16.6456C34.7591 17.3001 33.7847 18.0267 32.073 18.0267C29.4353 18.0267 27.3698 15.7815 27.3698 12.9995C27.3698 10.2176 29.4353 7.97234 32.073 7.97234C33.4992 7.97234 34.537 8.56015 35.3028 9.32209L36.5677 7.98805C35.4965 6.90929 34.0715 6.08059 32.073 6.08059C28.4559 6.08059 25.416 9.18462 25.416 12.9995C25.416 16.8144 28.4559 19.9185 32.073 19.9185C34.028 19.9185 35.4965 19.2429 36.6509 17.9757C37.8338 16.728 38.2025 14.9738 38.2025 13.5572C38.2025 13.1174 38.1677 12.7128 38.1056 12.3751H32.073ZM77.0645 13.8426C76.7157 12.8464 75.6396 11.0096 73.4474 11.0096C71.2752 11.0096 69.4667 12.8149 69.4667 15.4647C69.4667 17.96 71.2566 19.9185 73.656 19.9185C75.5961 19.9185 76.7157 18.6708 77.1763 17.9442L75.7364 16.9323C75.256 17.6733 74.6018 18.1642 73.656 18.1642C72.7163 18.1642 72.0423 17.7099 71.6103 16.8144L77.2594 14.3493L77.0645 13.8426ZM71.305 15.3259C71.2566 13.6083 72.5699 12.7285 73.5108 12.7285C74.2481 12.7285 74.8737 13.1174 75.0822 13.6738L71.305 15.3259ZM66.7135 19.6475H68.5704V6.55582H66.7135V19.6475ZM63.6723 12.0019H63.6103C63.1932 11.4809 62.3976 11.0096 61.3896 11.0096C59.2745 11.0096 57.3406 12.9681 57.3406 15.4791C57.3406 17.9757 59.2745 19.9185 61.3896 19.9185C62.3976 19.9185 63.1932 19.4432 63.6103 18.9065H63.6723V19.5454C63.6723 21.2486 62.8097 22.1637 61.4182 22.1637C60.2836 22.1637 59.5798 21.2996 59.2894 20.5731L57.6745 21.2839C58.1399 22.4648 59.3725 23.918 61.4182 23.918C63.5954 23.918 65.4325 22.5669 65.4325 19.2796V11.2806H63.6723V12.0019ZM61.5485 18.1642C60.2688 18.1642 59.1975 17.0344 59.1975 15.4791C59.1975 13.9094 60.2688 12.7639 61.5485 12.7639C62.8097 12.7639 63.8039 13.9094 63.8039 15.4791C63.8039 17.0344 62.8097 18.1642 61.5485 18.1642ZM85.7585 6.55582H81.3172V19.6475H83.1692V14.687H85.7585C87.8153 14.687 89.8324 13.1174 89.8324 10.6208C89.8324 8.12551 87.8103 6.55582 85.7585 6.55582ZM85.8069 12.866H83.1692V8.37687H85.8069C87.1897 8.37687 87.9791 9.58784 87.9791 10.6208C87.9791 11.6341 87.1897 12.866 85.8069 12.866ZM97.2553 10.9847C95.9171 10.9847 94.5257 11.6079 93.9534 12.9891L95.5969 13.7156C95.9507 12.9891 96.6011 12.7534 97.2888 12.7534C98.2495 12.7534 99.2239 13.3622 99.2388 14.437V14.5745C98.9037 14.3702 98.1862 14.0678 97.3037 14.0678C95.5336 14.0678 93.73 15.0955 93.73 17.0134C93.73 18.7677 95.1798 19.8975 96.8096 19.8975C98.0559 19.8975 98.7435 19.3045 99.1755 18.6145H99.2388V19.6265H101.028V14.6046C101.028 12.2834 99.3841 10.9847 97.2553 10.9847ZM97.0318 18.159C96.4261 18.159 95.582 17.8421 95.582 17.0501C95.582 16.0368 96.6346 15.648 97.5457 15.648C98.3612 15.648 98.7435 15.8378 99.2388 16.0879C99.0936 17.3001 98.1043 18.159 97.0318 18.159ZM107.544 11.2714L105.415 16.9467H105.352L103.151 11.2714H101.154L104.461 19.2024L102.574 23.6156H104.509L109.605 11.2714H107.544ZM90.8502 19.6475H92.7072V6.55582H90.8502V19.6475Z",
    fill: "#1C1C1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5249_43499",
    x1: 9.11493,
    y1: 23.7753,
    x2: -3.91587,
    y2: 11.4202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5249_43499",
    x1: 17.9831,
    y1: 14.9962,
    x2: 0.14424,
    y2: 14.9962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5249_43499",
    x1: 11.3467,
    y1: 13.2123,
    x2: -6.32415,
    y2: -3.54227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5249_43499",
    x1: -1.57691,
    y1: 30.4122,
    x2: 6.3139,
    y2: 22.9306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/PlayStore.08a1411f90d43041a62ae3258d61f129.svg";
export { ForwardRef as ReactComponent };